import type { RouteLocationNormalized } from "#vue-router";

// TODO положить isNumber в отдельное место
export const isNumber = (value:any) => /^\d+$/.test(value);
export const validate = (route: RouteLocationNormalized) => route.params.id ? isNumber(route.params.id) : true;